export class ManufacturingOrderWithTask {
  constructor(
    public hash?: string,
    public code?: string,
    public projectNumber?: string,
    public elementCode?: number,
    public taskDescription?: string,
    public elementNumber?: number
  ) { }

  clone() {
    return new ManufacturingOrderWithTask(
      this.hash,
      this.code,
      this.projectNumber,
      this.elementCode,
      this.taskDescription,
      this.elementNumber
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/manufacturing-order-with-task.ts